import { render, staticRenderFns } from "./CandidateListAdd.vue?vue&type=template&id=138f2b7a&"
import script from "./CandidateListAdd.vue?vue&type=script&lang=js&"
export * from "./CandidateListAdd.vue?vue&type=script&lang=js&"
import style0 from "./CandidateListAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports